var cart_notice = document.querySelector('.mini-cart-content-notice-canada-shipping');
if ( cart_notice ) {
    fetch("/browsing_context_suggestions.json").then( async (response) => {
        const data = await response.json();
        console.log(data);
        if (data.detected_values && data.detected_values.country.handle == 'PH' ) {
            cart_notice.classList.remove('hidden');
        }
    })
}